var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirecionar-app"},[_c('h1',{staticClass:"redirecionar-app__mensagem"},[_vm._v("Aguarde, estamos redirecionando você para o aplicativo...")])])
}]

export { render, staticRenderFns }